import { Command } from '../Command';
import { Notification, Toast } from '../UI';
import { generateDefault } from '../../../lib/utils';
import { commandList } from '../../../lib/command-list';

const ShowNotificationCommand = Command.extend({
  detail: Notification,
}).defaultTo(
  generateDefault({
    action: commandList.SHOW_NOTIFICATION,
  })
);

const ShowToastCommand = Command.extend({
  detail: Toast,
}).defaultTo(
  generateDefault({
    action: commandList.SHOW_TOAST,
  })
);

const ChangeThemeColorCommand = Command.extend({
  detail: {
    content: String,
  },
}).defaultTo(
  generateDefault({
    action: commandList.CHANGE_THEME_COLOR,
  })
);

const RemoteUIReadyCommand = Command.extend({
  detail: {
    timestamp: [Number],
    isInlineActivity: Boolean,
  },
}).defaultTo(
  generateDefault({
    action: commandList.REMOTE_UI_IS_READY,
  })
);

const SyncLoadingProgressCommand = Command.extend({
  detail: {
    percentage: [Number],
  },
}).defaultTo(
  generateDefault({
    action: commandList.SYNC_LOADING_PROGRESS,
  })
);

// When focus is on remote iframe, "detail" would be true, otherwise be false.
const IframeHasFocusCommand = Command.extend({
  detail: Boolean,
}).defaultTo(
  generateDefault({
    action: commandList.IFRAME_HAS_FOCUS,
  })
);

export {
  ShowNotificationCommand,
  ShowToastCommand,
  ChangeThemeColorCommand,
  RemoteUIReadyCommand,
  SyncLoadingProgressCommand,
  IframeHasFocusCommand,
};
